import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import AddNewPlant from "./pages/addNewPlant";
import Home from "./pages/appHome";
import PlantsPage from "./pages/plantsPage";
import RoAdvisorHome from "./pages/home";
import LifetimeAdvisorHome from "./pages/lifetimeAdvisorHome";
import AnalyseData from "./pages/analyseData";
import { RootLayout } from "./RootLayout";

import { updatePlantId } from "./utils/Utils";
import { API_URLS } from "./network/appUrls";
import NotAuthorized from "./pages/unauthorized";
import RequestAccess from "./pages/requesAccessPage";
import MessagePage from "./pages/messageDisplayPage";
import AdminPage from "./pages/AdminPortal";
import UserPage from "./pages/AdminPortal/userManage";
import { APP_ROUTES } from "./constants/global.constants";

const searchParams = new URLSearchParams(window.location.search);
const plantId = searchParams.get("plantId");
updatePlantId(plantId);

const basePath = API_URLS.basePath;

const routes = [
  {
    element: <RootLayout />,
    children: [
      {
        path: APP_ROUTES.ROOT,
        element: <PlantsPage />,
      },
      {
        path: APP_ROUTES.PLANTS,
        element: <PlantsPage />,
      },
      // remove this route later(added for users who have bookmarked /plant page, to avoid breaking their bookmark)
      {
        path: APP_ROUTES.PLANT_LEGACY,
        element: <Navigate to={`/${APP_ROUTES.PLANTS}`} replace />,
      },
      {
        path: APP_ROUTES.ADD_PLANT,
        element: <AddNewPlant />,
      },
      {
        path: APP_ROUTES.EDIT_PLANT,
        element: <AddNewPlant />,
      },
      {
        path: APP_ROUTES.ANALYSE_DATA,
        element: <AnalyseData />,
      },
      {
        path: APP_ROUTES.HOME,
        element: <Home />,
      },
      {
        path: APP_ROUTES.CLEANING_ADVISOR_HOME,
        element: <RoAdvisorHome />,
      },
      {
        path: APP_ROUTES.LIFETIME_ADVISOR_HOME,
        element: <LifetimeAdvisorHome />,
      },
      {
        path: APP_ROUTES.UNAUTHORIZED,
        element: <NotAuthorized />,
      },
      {
        path: APP_ROUTES.REQUEST_ACCESS,
        element: <RequestAccess />,
      },
      {
        path: APP_ROUTES.MESSAGE_PAGE,
        element: <MessagePage />,
      },
      {
        path: APP_ROUTES.ADMIN_PORTAL,
        element: <AdminPage />,
      },
      {
        path: APP_ROUTES.USER_MANAGEMENT,
        element: <UserPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: basePath,
});
